import React from 'react';

import TableWithSearch from 'components/Lists/TableWithSearch';
import { ALGOLIA, EXTERNAL_LINKS } from 'config/constants';
import TracksTable from 'components/TracksTable';
import NoDataDisplay from 'components/NoDataDisplay';
import Button from 'components/Button';
import { GetLabelAndViewerQuery } from 'gql/graphql';

interface LabelTracksProps {
  label: NonNullable<GetLabelAndViewerQuery['label']>;
  labelId: string;
  canEditLabel?: boolean;
  loading: boolean;
}
const LabelTracks = ({ label, labelId, canEditLabel, loading }: LabelTracksProps) => {
  const placeholderText = loading ? 'Loading...' : `Search Tracks from ${label.name}`;

  return (
    <TableWithSearch
      index={ALGOLIA.TRACK_INDEX}
      facetFilters={[`label.id:${labelId}`]}
      // For now, only return compiled tracks
      filters="compiled=0"
      restrictSearchableAttributes={TracksTable.SEARCHABLE_ATTRIBUTES}
      placeholderText={placeholderText}
      limitReachedText={label.name ? ` from ${label.name}` : null}
      renderLoading={() => <TracksTable.Tombstones wrapped />}
      renderTable={({ data, ...rest }) => <TracksTable tracks={data} {...rest} />}
      renderEmpty={() => (
        <div className="container-fluid">
          <NoDataDisplay
            text={
              canEditLabel
                ? 'No music on pre-order or promo yet!'
                : 'This label has not released any tracks through Proton yet.'
            }
          >
            {canEditLabel && (
              <Button to={EXTERNAL_LINKS.SOUNDSYSTEM.LABELS} newTab rounded>
                Go to SoundSystem
              </Button>
            )}
          </NoDataDisplay>
        </div>
      )}
    />
  );
};

export default LabelTracks;
